import React from "react";
import { motion } from "framer-motion";
import { Check, Lock } from "lucide-react";

export default function PhaseNav({ phases, current, onSelect }) {
  return (
    <div className="w-full overflow-x-auto pb-2" data-testid="phase-nav">
      <div className="flex min-w-max items-center gap-1 sm:gap-2">
        {phases.map((p, i) => {
          const isActive = current === p.n;
          return (
            <React.Fragment key={p.n}>
              <button
                onClick={() => onSelect(p.n)}
                data-testid={`phase-nav-${p.n}`}
                className="group flex flex-col items-center gap-2 px-1 outline-none"
              >
                <div className="relative">
                  <motion.span
                    animate={{ scale: isActive ? 1.1 : 1 }}
                    className={`grid h-11 w-11 place-items-center rounded-full border-2 text-sm font-bold transition-colors
                      ${isActive ? "border-primary bg-primary text-primary-foreground shadow-lg shadow-primary/30"
                        : p.done ? "border-primary/40 bg-secondary text-primary"
                        : "border-border bg-card text-muted-foreground group-hover:border-primary/50"}`}
                  >
                    {p.locked ? <Lock className="h-4 w-4" /> : p.done ? <Check className="h-5 w-5" /> : p.n}
                  </motion.span>
                </div>
                <span className={`max-w-[88px] text-center text-[11px] font-semibold leading-tight ${isActive ? "text-primary" : "text-muted-foreground"}`}>
                  {p.title}
                </span>
              </button>
              {i < phases.length - 1 && (
                <div className={`mt-[-26px] h-0.5 w-6 shrink-0 rounded sm:w-10 ${p.done ? "bg-primary/50" : "bg-border"}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
